import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { ApiFilter } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/semeTp";

export const createSeedTestStationAnalysis = createAsyncThunk(
  "seed/testStation/create",
  async (dto, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateSeedTestStationAnalysis = createAsyncThunk(
  "seed/testStation/update",
  async ({ dto, id }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(`${baseUrl}/${id}`, dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getSeedTestStationAnalysisById = createAsyncThunk(
  "seed/testStation/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getSeedTestStationAnalysisBySeedAnalysisId = createAsyncThunk(
  "seed/testStation/getBySeedAnalysisId",
  async (id, { rejectWithValue }) => {
    try {
      const filter = new ApiFilter().where("semeVzorecId", "EQ", id);
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        null,
        filter,
        null,
        false
      );
      if (response.data.content?.length === 0) {
        return null;
      }
      return response.data.content?.[0];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getSeedTestStationAnalysisPage = createAsyncThunk(
  "seed/testStation/getPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const thunks = [
  createSeedTestStationAnalysis,
  updateSeedTestStationAnalysis,
  getSeedTestStationAnalysisById,
  getSeedTestStationAnalysisPage,
  getSeedTestStationAnalysisBySeedAnalysisId,
];

const seedTestStationSlice = createSlice({
  name: "seedTestStation",
  initialState: {
    isLoading: false,
    error: null,
    page: {},
    details: {},
    byBasicAnalysisId: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSeedTestStationAnalysis.fulfilled, (state, action) => {
        state.details = action.payload;
      })
      .addCase(getSeedTestStationAnalysisPage.fulfilled, (state, action) => {
        state.page = action.payload;
        action.payload.content.map((testStationAnalysis) => {
          state.byBasicAnalysisId[testStationAnalysis.semeVzorecId] =
            testStationAnalysis;
        });
      })
      .addCase(getSeedTestStationAnalysisById.fulfilled, (state, action) => {
        state.details = action.payload;
        state.byBasicAnalysisId[action.payload.semeVzorecId] = action.payload;
      })
      .addCase(updateSeedTestStationAnalysis.fulfilled, (state, action) => {
        state.details = action.payload;
      })
      .addCase(
        getSeedTestStationAnalysisBySeedAnalysisId.fulfilled,
        (state, action) => {
          state.details = action.payload;
        }
      )
      .addMatcher(
        isAnyOf(...thunks.map((t) => t.rejected)),
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addMatcher(isAnyOf(...thunks.map((t) => t.pending)), (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isAnyOf(...thunks.map((t) => t.fulfilled)), (state, _) => {
        state.isLoading = false;
      });
  },
});

export default seedTestStationSlice.reducer;
